import styled from '@emotion/styled';

import { SemboSizeTypes } from './PrimaryIcon.types';

export const ImageWrapper = styled.img`
  width: ${SemboSizeTypes['MEDIUM'].w}px;
  height: ${SemboSizeTypes['MEDIUM'].h}px;

  @media (min-width: 768px) {
    width: ${SemboSizeTypes['LARGE'].w}px;
    height: ${SemboSizeTypes['LARGE'].h}px;
  }
`;
